export default __webpack_public_path__ + "static/media/bank.aa04353c.png";